<div class="confirmation-message-inner-container rb-theme">
    <div class="wp_flex--container wp-mb-10">
        <div class="wp_flex__item--inherit">
            <h4 class="wp-heading-4 rb-mobile-font-bold rb-mobile-font-16">{{displayHeaderMessage}}</h4>
        </div>
    </div>
    <div class="wp_flex--container wp-mb-20">
        <div class="wp_flex__item--inherit">
            <div class="wp-txt-body1 wp-txt--secondary  rb-mobile-font-14">{{displayMessage}} ?</div>
        </div>
    </div>
    <div class="wp_flex--container justify-content-end">
        <div class="wp_flex__item--inherit wp-mr-10 rb-w-100">
            <button mat-button class="mat-btn-secondary--small rb-w-100" (click)="confrim('yes')" (keydown.enter)="confrim('yes')" tabindex="0">Yes</button>
        </div>
        <div class="wp_flex__item--inherit rb-w-100">
            <button mat-button class="mat-btn-primary--small rb-w-100" (click)="confrim('no')" (keydown.enter)="confrim('no')" tabindex="0">No</button>
        </div>
    </div>
</div>
